<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import { Form, FormItem, Input, Switch, Tooltip, Checkbox, Select, Option } from 'element-ui';
    import Vue from "vue";

    Vue.use(Input);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Switch);
    Vue.use(Tooltip);
    Vue.use(Checkbox);
    Vue.use(Select);
    Vue.use(Option);

    export default {
        name: 'mfa-settings-form',

        computed: {
            ...mapState('passwordSettings', [
                'mfaSettingsForm',
                'allAdminUsers',
            ]),
        },
    }
</script>

<template>
    <el-form
        ref="mfaSettingsForm"
        :model="mfaSettingsForm"
    >
        <el-form-item prop="enabled">
            <div class="ps-mfa-form__toggle-label">
                Enable multi-factor authentication
            </div>

            <div class="ps-form__action">
                <el-switch
                    v-model="mfaSettingsForm.enabled"
                    on-text="Yes"
                    off-text="No"
                    on-value="1"
                    off-value="0"
                    :width="60">
                </el-switch>
            </div>
        </el-form-item>

        <el-form-item prop="required">
            <div class="ps-mfa-form__toggle-label">
                Require multi-factor authentication for all users
            </div>

            <div class="ps-form__action">
                <el-switch
                    v-model="mfaSettingsForm.required"
                    on-text="Yes"
                    off-text="No"
                    on-value="1"
                    off-value="0"
                    :width="60">
                </el-switch>
            </div>
        </el-form-item>

        <p class="muted-help-text">
            <span class="bold">Note:</span>
            <span>Multi-factor authentication applies to native logins only. Users logging in through SSO will not be affected.</span>
        </p>
<!--
        <el-form-item prop="required">
            <div class="ps-mfa-form__toggle-label">
                Allow SMS authentication
            </div>
            <div class="ps-form__action">
                <el-switch
                    v-model="mfaSettingsForm.use_sms"
                    on-text="Yes"
                    off-text="No"
                    on-value="1"
                    off-value="0"
                    :width="60">
                </el-switch>
            </div>

            <p class="muted-help-text">Authentication apps are enabled by default</p>
        </el-form-item>
-->
        <hr class="ps-form__hr">

        <h5 class="el-form-item__label">Reset Requests</h5>

        <el-form-item>
            <p class="ps-mfa-form__label">Notify the following admin user(s):</p>
            <el-select
                v-model="mfaSettingsForm.admin_users_ids"
                multiple
                clearable
                filterable
                placeholder="Select"
                class="ps-mfa-form__toggle-label"
            >
                <el-option
                    v-for="user in allAdminUsers"
                    :key="user.user_id"
                    :value="user.user_id"
                    :label="user.user_full_name"
                >
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item prop="auto_reset">
            <el-checkbox
                v-model="mfaSettingsForm.auto_reset"
                true-label="1"
                false-label="0"
            >
                Allow automatic user reset
                <el-tooltip
                    class="ps-tooltip"
                    effect="dark"
                    placement="top"
                    popper-class="ps-tooltip-content"
                    content="If logged in, users can reset their own multi-factor authentication settings without admin approval.">
                    <i class="fa fa-question-circle m-l-3 ps-auto-reset"></i>
                </el-tooltip>

            </el-checkbox>
        </el-form-item>

        <el-form-item>
            <p class="muted-help-text">
                <span class="bold">Note:</span>
                <span>The assigned admin user(s) will always receive a notification when a reset request is sent from the login page.</span>
            </p>
        </el-form-item>
    </el-form>
</template>
